import "./common.ts";
import "../portico/legacy_header.ts";
import "../portico/google-analytics.ts";
import "../portico/portico_modals.ts";
import "../portico/tippyjs.ts";
import "../portico/help.ts";
import "../../styles/portico/portico_variables.css";
import "../../styles/components.css";
import "../../styles/portico/legacy_portico.css";
import "../../styles/portico/markdown.css";
import "tippy.js/dist/tippy.css";
